import styled from "styled-components";
import couple from "../../assets/welcome-background.png";

export const StyledWelcome = styled.section`
padding: 0;
margin: 0;
    background-color: #f6fdff;
    width: 100%;
    height: 39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    overflow: hidden;
    margin-bottom: 0rem;
    @media only screen and (min-width: 475px) {
      background-image: url(${couple});
      background-size: 40rem;
      background-repeat: no-repeat;
      background-position: top right;
      height: 38rem;
    }
    @media only screen and (min-width: 1000px) {
      background-size: 60vw;
      height: 46vw;
    }
    
  `,
  StyleRow = styled.div`
    @media only screen and (max-width: 767.9px) {
      display:flex;
      flex-direction: column-reverse;
    }
  `,

  TextBox = styled.div`
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #444444;
    
    @media only screen and (min-width: 320px) {
      padding: 2rem 0 0 3.25rem;

     
    }
    @media only screen and (min-width: 375px) {
      padding: 2rem 0 0 1rem;
      
    }
  
    @media only screen and (min-width: 768px) {
      padding: 5rem 0 0 4rem;
    }
    @media only screen and (min-width: 1000px) {
      padding: 5rem 0 0 3rem;
    }
  `,
  TextColumn = styled.div`
    padding: 0;
    margin: 0;
    border-radius: 5px 5px 5px 5px;
    //background-color: rgb(246, 253, 255, 0.8);
    //min-width: 18rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    
    @media only screen and (min-width: 475px) {
      //margin-right: 30vw;
      //margin-top: 4rem;
      //min-width: 20rem;
      align-items: flex-start;
      border-radius: 10px 50% 10px 10px;
    }
    @media only screen and (min-width: 1000px) {
      background-color: rgb(246, 253, 255, 0);
      margin-top: 0;
    }
  `,
  Hashtag = styled.h1`
    padding: 0;
    //margin: 11vw 0 0 0;
    font-style: normal;
    font-weight: 500;
    font-size: 25px;
    color: #083F88;
    padding: 1vw 0vw;
    width: 100%;
    @media only screen and (min-width: 320px) and (max-width: 400px) {
      font-size: 15px;
    }
    @media only screen and (min-width: 320px) and (max-width: 575px) {
      margin-top: 65px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2vw;
    }
  `,
  Circle = styled.img`
  padding: 0;
  margin: 0;
    position: absolute;
    height: 4.25rem;
    margin-top: -5.2rem;
    margin-left: 2.9rem;
    @-moz-document url-prefix() {
      margin-top: -10rem;
      margin-left: 6rem;
    }
    @media only screen and (min-width: 475px) {
      margin-top: -3.25rem;
      margin-left: 6.55rem;
      height: 4.5rem;
    }
    @media only screen and (min-width: 600px) {
      margin-top: -4rem;
      margin-left: 6.25rem;
      height: 4.7rem;
    }

    @media only screen and (min-width: 1000px) {
      height: 7.5vw;
      margin-top: -4vw;
      margin-left: 10.3vw;
    }
    @media only screen and (min-width: 1500px) {
      margin-top: -4vw;
    }
  `,
  Strong = styled.h4`
  font-size:1.5vw;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  font-style:Poppins;
  color:#083F88;
  @media only screen and (max-width: 474px) {
    font-size:15px;
  }
  @media only screen and (min-width: 475px) {
    font-size:16px;
  }
  @media only screen and (min-width: 1000px) {
    font-size:18px;
  }
  `,
  TextBox1 = styled.h2`
  font-size:3.2vw;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  text-transform: capitalize;
  color:#083F88;
  width: 100%;
  @media only screen and (min-width: 320px) and (max-width: 400px) {
    font-size: 18px !important;
  }
  @media only screen and (max-width: 600px) {
    font-size: 22px;
  }

  `,
  BoldText = styled.h1`

    padding: 0;
    margin: 0;
    font-size: 35px;
    color: #083f88;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    width: 100%;
    
    @media only screen and (min-width: 320px) and (max-width: 400px) {
      font-size: 22px !important;
    }
    @media only screen and (min-width: 475px) {
      font-size: 23px;
    }
    @media only screen and (min-width: 768px) {
      font-size: 26px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 3.4vw;
    }
    @media only screen and (max-width: 474px) {
      font-size: 28px;
    }
    @media only screen and (max-width: 375px) {
      font-size: 24px;
    }
  `,
  Subtext = styled.p`
  padding: 0;
  margin: 0;
    font-weight: 300;
    font-size: 13px;
    text-align: left;
    padding: 0.25rem;
    width: 18rem;
    color: #083F88;
    
    @media only screen and (min-width: 320px) and (max-width: 374.9px) {
      font-size: 13px;
      padding-right: 45px;
    }
    @media only screen and (min-width: 375px) and (max-width: 400px) {
      font-size: 13px;
      padding-right: 18px;
    }
    @media only screen and (min-width: 475px) {
      text-align: left;
      line-height: 1.2;
      padding: 0.25rem;
      width: 100%;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.15vw;
      line-height: 1.6;
    }
  `,
  Text = styled.h1`
  padding: 0;
  margin: 0;
    padding: 0.75rem 1.5rem 0.5rem 1.5rem;
    text-align: left;
    color: #083f88;
    white-space: nowrap;
    font-size: 15px;
    transition: color 0.4s;
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
      padding: 1vw 2vw 0.75vw 2vw;
    }
  `,
  Button = styled.div`
   padding: 0;
    // margin: 11vw;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 15px 40px rgba(82, 67, 170, 0.2);
    border-radius: 25px;
    background: transparent;
    border: 2px solid #083f88;
    transition: background-color 0.4s;
    cursor: pointer;
    margin-top: 5px;
    &:hover {
      background-color: #083f88;
    }
    @media only screen and (min-width: 320px) and (max-width: 374.9px) {
      margin-right: 80px;
    }
    @media only screen and (min-width: 1000px) {
      border-radius: 2.5vw;
    }
    @media only screen and (min-width: 767px) {
      margin-left:0;
    }
    &: hover ${Text} {
      color: #ffffff;
    }
  `;
